module.exports = __webpack_public_path__ + "img/logo1.6d62c38a.png";